/**
 * O que a tela diz depois de salvar um ajuste do robô (spec
 * 2026-09-24-robo-painel-de-ajustes, 4.7). Puro, para o vitest cobrir cada
 * estado sem montar página.
 *
 * A regra que não se negocia: "reagiu" só com o recibo (`ack` do robô). Nunca
 * "salvo e ele reagiu" por suposição — é a regra do Motor Único, a prova é a
 * linha registrada.
 */
import {
  MODELO_LABEL, type AvisoDoAjuste, type HardwareModel, type ReciboDoAviso,
} from '@/api/robo'

export type TomDoAviso = 'reagiu' | 'aguardando' | 'atencao'
export type MensagemDoAviso = { tom: TomDoAviso; texto: string }

/** "Robô II", ou "robô" quando a placa ainda não foi identificada. */
export function rotuloDoRobo(modelo: HardwareModel | null | undefined): string {
  return modelo ? MODELO_LABEL[modelo] : 'robô'
}

/**
 * `robo` é o rótulo de `rotuloDoRobo`; `recibo`, o último lido de
 * `GET .../aviso/{id}` (`undefined` antes da primeira leitura); `prazoPassou`,
 * se a tela já desistiu de perguntar (25 s).
 */
export function mensagemDoAviso(
  aviso: AvisoDoAjuste,
  recibo: ReciboDoAviso | undefined,
  robo: string,
  prazoPassou = false,
): MensagemDoAviso {
  const vale = 'o ajuste vale do mesmo jeito'
  if (aviso.estado === 'offline') {
    return { tom: 'atencao', texto: `O ${robo} está offline; o ajuste vale na próxima conexão.` }
  }
  if (aviso.estado === 'sem_aviso1') {
    return { tom: 'atencao', texto: `O firmware do ${robo} não mostra avisos; atualize.` }
  }
  if (aviso.estado === 'indisponivel') {
    return { tom: 'atencao', texto: `Não deu para avisar o ${robo} agora; ${vale}.` }
  }
  // `publicado` ou `ocupado`: daqui em diante quem decide é o recibo.
  if (recibo === 'reagiu') return { tom: 'reagiu', texto: `O ${robo} reagiu.` }
  if (recibo === 'ocupado') {
    return { tom: 'atencao', texto: `O ${robo} estava ocupado mostrando outra coisa; ${vale}.` }
  }
  if (recibo === 'indisponivel') {
    return { tom: 'atencao', texto: `Não deu para confirmar se o ${robo} reagiu; ${vale}.` }
  }
  if (recibo === 'expirou' || prazoPassou) {
    return { tom: 'atencao', texto: `O ${robo} não mostrou o aviso a tempo; ${vale}.` }
  }
  if (aviso.estado === 'ocupado') {
    return { tom: 'aguardando', texto: `O ${robo} estava ocupado mostrando outra coisa; tentando de novo…` }
  }
  return { tom: 'aguardando', texto: `Avisando o ${robo}…` }
}
